import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { Translate } from 'react-localize-redux';
import { bindActionCreators } from 'redux';
import { JumpingBeans } from './loadingComponent';
import { SECTIONS, reportActions } from '../../store/reportStore';
import { isNullOrUndefined } from '../../store/storeFunctions';
import Message from './message';
import BbCollapse from './BbCollapse';

import RelatedAddresses from '../reportSections/relations/relatedAddresses';
import LiensSection from '../reportSections/liens/liensSection';
import PublicContractsSection from '../reportSections/publicContracts/publicContractsSection';
import PublicProcurementsSection from '../reportSections/publicProcurements/publicProcurementsSection';
import WarningsSubSection from '../reportSections/warnings/warningsSubSection';
import RelationSubSection from '../reportSections/relations/relationSubSection';
import RelationCRSRSubSection from '../reportSections/relationsCRSR/relationCRSRSubSection';
import MirriFinalOwnersSubSection from '../reportSections/relations/mirriFinalOwnersSubSection';
import MirriPublicSectorPartnersSubSection from '../reportSections/relations/mirriPublicSectorPartnersSubSection';
import EsgSubfactorsSection from '../reportSections/esg/esgSubfactorSection';
import AngleDownIcon from '../../img/icons/BBiconsRozbalit';
import FinStatementsInfo from '../reportSections/finStatementsInfo';

class OldStyleSubsection extends React.Component {
    static defaultProps = {
        level: 2,
        subsectionData: {},
        hideHeader: false
    };

    // Group subsections by sectionId
    knownSubsections = {
        "empty": () => (""),
        [SECTIONS.relatedAddresses]: RelationSubSection,
        [`${SECTIONS.liensItems}_CR`]: LiensSection,
        [`${SECTIONS.liensItems}_DE`]: LiensSection,
        [`${SECTIONS.publicContractsItems}_01`]: PublicContractsSection,
        [`${SECTIONS.publicContractsItems}_02`]: PublicContractsSection,
        [`${SECTIONS.publicProcurements}_A`]: PublicProcurementsSection,
        [`${SECTIONS.publicProcurements}_S`]: PublicProcurementsSection,
        [SECTIONS.shortReportRelatedAddresses]: RelatedAddresses,
        [`${SECTIONS.warningItems}_WarningsInfo`]: WarningsSubSection,
        [`${SECTIONS.warningItems}_InsolvencyRegister`]: WarningsSubSection,
        [`${SECTIONS.warningItems}_InsolvencyRegisterAll`]: WarningsSubSection,
        [`${SECTIONS.warningItems}_Debts`]: WarningsSubSection,
        [`${SECTIONS.warningItems}_SupplementaryInfo`]: WarningsSubSection,
        [`${SECTIONS.mirriWarningItems}_WarningsInfo`]: WarningsSubSection,
        [`${SECTIONS.mirriWarningItems}_InsolvencyRegister`]: WarningsSubSection,
        [`${SECTIONS.mirriWarningItems}_InsolvencyRegisterAll`]: WarningsSubSection,
        [`${SECTIONS.mirriWarningItems}_Debts`]: WarningsSubSection,
        [`${SECTIONS.shortReportWarningItems}_WarningsInfo`]: WarningsSubSection,
        [`${SECTIONS.shortReportWarningItems}_InsolvencyRegister`]: WarningsSubSection,
        [`${SECTIONS.shortReportWarningItems}_InsolvencyRegisterAll`]: WarningsSubSection,
        [`${SECTIONS.shortReportWarningItems}_Debts`]: WarningsSubSection,
        [`${SECTIONS.shortReportWarningItems}_SupplementaryInfo`]: WarningsSubSection,
        [`${SECTIONS.warningsReportWarningItems}_WarningsInfo`]: WarningsSubSection,
        [`${SECTIONS.warningsReportWarningItems}_InsolvencyRegister`]: WarningsSubSection,
        [`${SECTIONS.warningsReportWarningItems}_InsolvencyRegisterAll`]: WarningsSubSection,
        [`${SECTIONS.warningsReportWarningItems}_Debts`]: WarningsSubSection,
        [`${SECTIONS.warningsReportWarningItems}_SupplementaryInfo`]: WarningsSubSection,
        [SECTIONS.relationItems]: RelationSubSection,
        [SECTIONS.relationCRSRItems]: RelationCRSRSubSection,
        [`${SECTIONS.mirriPublicContractsItems}_01`]: PublicContractsSection,
        [`${SECTIONS.mirriPublicContractsItems}_02`]: PublicContractsSection,
        [SECTIONS.mirriPublicSectorPartner]: MirriPublicSectorPartnersSubSection,
        [SECTIONS.mirriFinalOwner]: MirriFinalOwnersSubSection,
        [SECTIONS.esgSubfactorsE]: EsgSubfactorsSection,
        [SECTIONS.esgSubfactorsS]: EsgSubfactorsSection,
        [SECTIONS.esgSubfactorsG]: EsgSubfactorsSection,
        [SECTIONS.finStatementsInfo]: FinStatementsInfo
    };

    componentDidMount() {
        this.props.attachSectionElement(this.props.subsectionId, this.holder);
        this.props.loadIfSubsectionExpanded(this.props.sectionId, this.props.subsectionId);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.report.isExpandAllActivated !== this.props.report.isExpandAllActivated && this.props.report.isExpandAllActivated) {
            this.props.loadIfSubsectionExpanded(this.props.sectionId, this.props.subsectionId);
        }
    }

    getNextSection = () => {
        let parent = this.props.report.sections.find(o => o.id === this.props.sectionId)
        if (parent === undefined || parent === null)
            return null;

        let nextId = parent.subsections.find(o => o.id === this.props.subsectionId).orderId;
        return parent.subsections.find(o => o.orderId > nextId && !o.hidden);
    }

    scrollToNextSection = () => {
        let nextSection = this.getNextSection();
        if (nextSection !== undefined)
            this.props.report.elements[nextSection.id].scrollIntoView({ behavior: "smooth", block: 'start' });
    }

    render() {
        const { sectionId, subsectionId, subsectionData, subsectionName, isBold, level } = this.props;
        const TagName = subsectionId.startsWith(`${SECTIONS.relationItems}_`) ? this.knownSubsections[SECTIONS.relationItems] :
            subsectionId.startsWith(`${SECTIONS.relationCRSRItems}_`) ? this.knownSubsections[SECTIONS.relationCRSRItems] : this.knownSubsections[subsectionId] || this.knownSubsections["empty"];
        const parentSection = this.props.report.sections.find(o => o.id === sectionId);

        if (parentSection === undefined || parentSection === null)
            return null;
        if (parentSection.subsections === undefined || parentSection.subsections === null || parentSection.subsections.length === 0)
            return null;
        if (parentSection.subsections.find(o => o.id === subsectionId) === undefined)
            return null;

        const { name, isLoading, expanded, hasData, error } = parentSection.subsections.find(o => o.id === subsectionId);

        return (
            <div data-level={level} className={classnames("old-style-report-section", { "is-expanded": expanded && hasData, 'old-style-no-data': !hasData })}
                ref={(el) => this.holder = el} style={{ pointerEvents: hasData ? "auto" : "none" }}
            >

                <div className="old-style-header-body" onClick={() => this.headerClick(sectionId, subsectionId, expanded)} style={{ display: this.props.hideHeader && !isLoading ? 'none' : null }}>
                    {this.renderIcon(expanded, hasData)}
                    <div style={{ fontWeight: isBold && hasData ? "bold" : "normal" }}>{isNullOrUndefined(subsectionName) ? name : subsectionName}</div>
                    {isLoading && <JumpingBeans />}
                    {!hasData && <span style={{ marginLeft: "auto" }}><Translate id="Report.Common.NoData" /></span>}
                </div>

                {hasData && !isLoading && <BbCollapse className="old-style-report-section-body" id={sectionId} tag="div" isOpen={expanded && hasData}>
                    {error && <Message type='warning' message={<Translate id={error} options={{ renderInnerHtml: true }} />} />}
                    <TagName sectionId={sectionId} subsectionId={subsectionId} subsectionData={subsectionData} />
                </BbCollapse>}
            </div>
        );
    }

    renderIcon = (expanded, hasData) => {
        return !hasData ? (
            <div className="icon-wrap">
                <span style={{ fontWeight: this.props.isBold && this.props.hasData ? "bold" : "normal", width: '1.4em', textAlign: 'center', fontStyle: 'normal' }}>O</span>
            </div>
        ) : (
            <div className="icon-wrap">
                <AngleDownIcon
                    style={{ transform: `scaleY(${expanded ? -1 : 1})`, transition: 'all .5s ease', width: '1.4em', height: '1.4em' }}
                    className='svg-standard-fill' />
            </div>
        );
    }

    headerClick = (sectionId, subsectionId, expanded) => {
        this.props.toggleSubsection(sectionId, subsectionId, !expanded, subsectionId !== SECTIONS.relatedAddresses)
    }
}

export default connect(
    state => ({ report: state.report }),
    dispatch => bindActionCreators(reportActions, dispatch)
)(OldStyleSubsection);